export default function FloatingContactButton() {
  const handleClick = () => {
    window.dispatchEvent(new CustomEvent('open-contact-modal'));
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="fixed left-[32.5px] bottom-[28.5px] z-50 w-[78px] h-[78px] rounded-full bg-[#BE0F12] text-white flex flex-col items-center justify-center shadow-2xl hover:bg-[#A30D0F] hover:scale-105 active:scale-95 transition-all text-center p-2 group cursor-pointer"
      aria-label="Skriv til os"
    >
      <span className="font-['Saira'] font-bold text-[12px] uppercase leading-tight">Skriv</span>
      <span className="font-['Saira'] font-bold text-[10px] uppercase leading-tight">til os</span>
    </button>
  );
}
